import { Field } from 'formik'
import { RadioGroup as _RadioGroup } from 'formik-material-ui'
import React from 'react'

const RadioGroup = (props) => {
  return <Field component={_RadioGroup} {...props} />
}

export { RadioGroup }
